import { withSitecoreContext as withSitecoreNextJsContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
//@ts-ignore todo later
import { isUsingNext } from "../isUsingNext";
export var withSitecoreCustomContext = function withSitecoreCustomContext(props) {
  if (isUsingNext()) {
    var element = withSitecoreNextJsContext(props);
    return element;
  }
  return withSitecoreContext(props);
};